const isPictureElement = (element) => {
    const nodeName = element && (element.nodeName || element.tagName);
    return typeof nodeName === 'string' && nodeName.toLowerCase() === 'picture';
};

const promoteVehiclePicture = (picture) => {
    if (!isPictureElement(picture) || !picture.querySelectorAll) return;

    Array.prototype.forEach.call(picture.querySelectorAll('source'), (source) => {
        if (!source.hasAttribute('data-srcset')) return;

        source.setAttribute('srcset', source.getAttribute('data-srcset') || '');
        source.removeAttribute('data-srcset');
    });

    const image = picture.querySelector('img');
    if (image && image.hasAttribute('data-src')) {
        image.setAttribute('src', image.getAttribute('data-src') || '');
        image.removeAttribute('data-src');
    }
};

const onLazyImageReady = (swiper, slide, image) => {
    let picture = isPictureElement(image) ? image : null;

    if (!picture && image && isPictureElement(image.parentNode)) {
        picture = image.parentNode;
    }

    if (!picture && slide && slide.querySelector) {
        picture = slide.querySelector('picture.swiper-lazy') || slide.querySelector('picture');
    }

    promoteVehiclePicture(picture);
};

module.exports = {
    onLazyImageReady,
    promoteVehiclePicture
};
